var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWheel(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "100%",
    height: "100%",
    viewBox: "0 0 482.727 482.727",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n      fill: #313a48;\r\n      stroke: #fff;\r\n      stroke-width: 8px;\r\n      }\r\n\r\n      .cls-2, .cls-3 {\r\n      stroke: #7e848d;\r\n      stroke-width: 5px;\r\n      }\r\n\r\n      .cls-4 {\r\n      stroke: #d4d6d9;\r\n      stroke-width: 6px;\r\n      }\r\n\r\n      .cls-5 {\r\n      stroke: none;\r\n      }\r\n\r\n      .cls-6 {\r\n      fill: none;\r\n      }\r\n\r\n      .cls-7 {\r\n      filter: url(#Ellipse_215);\r\n      }\r\n\r\n      .cls-8 {\r\n      filter: url(#Text_1_-_12.5_8);\r\n      }\r\n\r\n      .cls-9 {\r\n      filter: url(#Text_1_-_12.5_7);\r\n      }\r\n\r\n      .cls-10 {\r\n      filter: url(#Text_1_-_12.5_6);\r\n      }\r\n\r\n      .cls-11 {\r\n      filter: url(#Text_1_-_12.5_5);\r\n      }\r\n\r\n      .cls-12 {\r\n      filter: url(#Text_1_-_12.5_4);\r\n      }\r\n\r\n      .cls-13 {\r\n      filter: url(#Text_1_-_12.5_3);\r\n      }\r\n\r\n      .cls-14 {\r\n      filter: url(#Text_1_-_12.5_2);\r\n      }\r\n\r\n      .cls-15 {\r\n      filter: url(#Text_1_-_12.5_);\r\n      }\r\n    "), /*#__PURE__*/React.createElement("filter", {
    id: "Text_1_-_12.5_",
    x: 237.857,
    y: 33.175,
    width: 222.404,
    height: 250.527,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#7e848d",
    floodOpacity: 0.502
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Text_1_-_12.5_2",
    x: 233.418,
    y: 114.639,
    width: 249.309,
    height: 211.532,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#7e848d",
    floodOpacity: 0.502
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Text_1_-_12.5_3",
    x: 199.025,
    y: 237.857,
    width: 250.527,
    height: 222.404,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-3"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#7e848d",
    floodOpacity: 0.502
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-3"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Text_1_-_12.5_4",
    x: 156.557,
    y: 233.417,
    width: 211.531,
    height: 249.31,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-4"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#7e848d",
    floodOpacity: 0.502
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-4"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Text_1_-_12.5_5",
    x: 22.467,
    y: 199.026,
    width: 222.404,
    height: 250.527,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-5"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#7e848d",
    floodOpacity: 0.502
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-5"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Text_1_-_12.5_6",
    x: 0,
    y: 156.557,
    width: 249.309,
    height: 211.532,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-6"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#7e848d",
    floodOpacity: 0.502
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-6"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Text_1_-_12.5_7",
    x: 33.176,
    y: 22.466,
    width: 250.527,
    height: 222.404,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-7"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#7e848d",
    floodOpacity: 0.502
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-7"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Text_1_-_12.5_8",
    x: 114.639,
    y: 0,
    width: 211.533,
    height: 249.31,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-8"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#7e848d",
    floodOpacity: 0.502
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-8"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_215",
    x: 191.563,
    y: 193.629,
    width: 99.609,
    height: 99.61,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-9"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.502
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-9"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4666",
    "data-name": "Groupe 4666",
    transform: "translate(23177.363 -6890.636)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_216",
    "data-name": "Ellipse 216",
    className: "cls-1",
    transform: "translate(-23170.625 6897.443)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 234.628,
    cy: 234.628,
    r: 234.628
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 234.628,
    cy: 234.628,
    r: 230.628
  })), /*#__PURE__*/React.createElement("g", {
    id: "Pie_chart",
    "data-name": "Pie chart",
    transform: "translate(-23086.215 6882) rotate(14)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-15",
    transform: "matrix(0.97, -0.24, 0.24, 0.97, -86.35, 30.43)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Text_1_-_12.5_9",
    "data-name": "Text (1 - 12.5%)",
    className: "cls-2 lc-wheel-wheel-svg-winning-case-internal",
    d: "M154.043,74.927A206.232,206.232,0,0,0,26.843,0L0,191.006Z",
    transform: "translate(297.64 45.78) rotate(14)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-14",
    transform: "matrix(0.97, -0.24, 0.24, 0.97, -86.35, 30.43)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Text_1_-_12.5_10",
    "data-name": "Text (1 - 12.5%)",
    className: "cls-3 lc-wheel-wheel-svg-losing-case-internal",
    d: "M191.006,142.925A206.233,206.233,0,0,0,154.043,0L0,116.08Z",
    transform: "translate(283.82 128.61) rotate(14)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-13",
    transform: "matrix(0.97, -0.24, 0.24, 0.97, -86.35, 30.43)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Text_1_-_12.5_11",
    "data-name": "Text (1 - 12.5%)",
    className: "cls-2 lc-wheel-wheel-svg-winning-case-internal",
    d: "M116.079,154.043a206.232,206.232,0,0,0,74.926-127.2L0,0Z",
    transform: "translate(251.61 251.44) rotate(14)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-12",
    transform: "matrix(0.97, -0.24, 0.24, 0.97, -86.35, 30.43)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Text_1_-_12.5_12",
    "data-name": "Text (1 - 12.5%)",
    className: "cls-3 lc-wheel-wheel-svg-losing-case-internal",
    d: "M0,191.005a206.233,206.233,0,0,0,142.925-36.963L26.845,0Z",
    transform: "translate(215.44 249.24) rotate(14)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-11",
    transform: "matrix(0.97, -0.24, 0.24, 0.97, -86.35, 30.43)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Text_1_-_12.5_13",
    "data-name": "Text (1 - 12.5%)",
    className: "cls-2 lc-wheel-wheel-svg-winning-case-internal",
    d: "M0,116.079a206.233,206.233,0,0,0,127.2,74.927L154.043,0Z",
    transform: "translate(81.82 214.35) rotate(14)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10",
    transform: "matrix(0.97, -0.24, 0.24, 0.97, -86.35, 30.43)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Text_1_-_12.5_14",
    "data-name": "Text (1 - 12.5%)",
    className: "cls-3 lc-wheel-wheel-svg-losing-case-internal",
    d: "M1.315,0A206.232,206.232,0,0,0,38.278,142.925L192.32,26.845Z",
    transform: "translate(46.88 168.92) rotate(14)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-9",
    transform: "matrix(0.97, -0.24, 0.24, 0.97, -86.35, 30.43)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Text_1_-_12.5_15",
    "data-name": "Text (1 - 12.5%)",
    className: "cls-2 lc-wheel-wheel-svg-winning-case-internal",
    d: "M74.927,0A206.235,206.235,0,0,0,0,127.2l191.005,26.844Z",
    transform: "translate(83.05 35.61) rotate(14)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-8",
    transform: "matrix(0.97, -0.24, 0.24, 0.97, -86.35, 30.43)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Text_1_-_12.5_16",
    "data-name": "Text (1 - 12.5%)",
    className: "cls-3 lc-wheel-wheel-svg-losing-case-internal",
    d: "M142.925,1.315A206.233,206.233,0,0,0,0,38.278L116.08,192.32Z",
    transform: "translate(175.13 12.3) rotate(14)"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-7",
    transform: "matrix(1, 0, 0, 1, -23177.36, 6890.64)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_215-2",
    "data-name": "Ellipse 215",
    className: "cls-4 lc-wheel-wheel-svg-central-circle-internal",
    transform: "translate(200.56 200.63)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 40.805,
    cy: 40.805,
    r: 40.805
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 40.805,
    cy: 40.805,
    r: 37.805
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWheel);
export default __webpack_public_path__ + "static/media/wheel.e254647a210e56026488b55e61c41f3e.svg";
export { ForwardRef as ReactComponent };